import { appConfigs } from "../config";

const {serverUrl, fileServer} = appConfigs;
const server = `${serverUrl}/lesson`;

const authPostHeader = (token) => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
    "Accept": "application/json"
})
/** create course category */
export const createCategory = (data, token) => {
    return fetch (`${server}/category`,{
        method: 'POST',
        headers: authPostHeader(token),
        body: JSON.stringify(data),
        mode: "cors"
    })
}

/** get all categories */
export const allCategories = () => {
    return fetch (`${server}/categories`,{
        method: "GET"
    })
} 
/** create a new course */
export const createCourse = (data, token) => {
    return fetch (`${server}/course`,{
        method: 'POST',
        headers: authPostHeader(token),
        body: JSON.stringify(data),
        mode: "cors"
    })
}

/** all courses */
export const allCourses = (signal) => {
    return fetch (`${server}/courses`,{
        method: "GET",
        mode: "cors",
        signal
    })
}

/** create a new lesson */
export const createLesson = (data, token) => {
    return fetch(`${server}/create`,{
        method: "POST",
        headers: authPostHeader(token),
        body: JSON.stringify(data)
    })
}

/** upload question documents */
export const uploadFile = (fileData) => {
    const formData = new FormData();
    formData.append("document", fileData);
    return fetch(`${fileServer}/document/upload`,{
        method: "POST",
        body: formData,
        headers:{
            Accept: "application/json"
        },
        mode: "cors"
    })
}

/** add questions to lesson */
export const addQuestions = (id, token) => {
    return fetch (`${server}/questions/${id}`,{
        method: "PATCH",
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

/** add question unit to lesson */
export const addQuestionUnit = (id, qUnit, token) => {
    return fetch (`${server}/question/${id}`,{
        method: "PATCH",
        headers: authPostHeader(token),
        body: JSON.stringify(qUnit),
        mode: "cors"
    })
}

/** update question unit */
export const updateQuestionUnit = (id, qUnit, qId, token) => {
    return fetch (`${server}/updateq/${id}`,{
        method: "PATCH",
        headers: authPostHeader(token),
        body: JSON.stringify({qUnit, qId}),
        mode: "cors"
    })
}

/** gell all lessons in a field */
export const getAllLessonsByField = (field) => {
    return fetch (`${server}/all/${field}`,{
        method: "GET",
        mode: "cors"
    })
}

/** get evaluation questions */
export const loadEvalQuestions = (id) => {
    return fetch (`${server}/eval/${id}`,{
        method: "GET",
        mode: "cors"
    })
}

/** learner placement */
export const learnerPlacement = (token) => {
    return fetch (`${serverUrl}/account/placement`, {
        method: "PATCH",
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}